import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  /**
   * Validates Swedish postal codes.
   * Must be exactly 5 digits, with optional space between 3rd and 4th digit.
   * Valid formats: "12345" or "123 45"
   */
  static postalCode(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }
    const postalCodeRegex = /^\d{3}\s?\d{2}$/;
    if (postalCodeRegex.test(control.value)) {
      return null;
    }
    return { postalCode: true };
  }

  static floorNumbers(control: AbstractControl): ValidationErrors | null {
    const formGroup = control as UntypedFormGroup;
    const livingFloor = formGroup.controls['floor'].value;
    const totalFloors = formGroup.controls['totalNumberFloors'].value;
    if (!livingFloor || !totalFloors || totalFloors > livingFloor || totalFloors === livingFloor) {
      return null;
    } else {
      return { floors: true };
    }
  }

  static expandedMailValidator(control: AbstractControl): ValidationErrors | null {
    const regularExpresion = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-üåäö]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (control.value.match(regularExpresion)) {
      return null;
    } else {
      return { email: true };
    }
  }
}
